<template>
  <div>
    <div style="display: flex;" class="fob-only-for-print-view fob-entity-list-options">

      <!-- RESEARCH ACTIVITY | filter tags -->
      <div>
        <b-field class="fob-entity-list-filter-tags fob-entity-list-options-tag-list-static" grouped group-multiline>
          <div style="display: flex; flex-flow: row wrap; align-content: space-between;">
            <div v-for="(value, field) in activeFilter" :key="field">
              <b-taglist v-if="value && value.length > 0" attached>
                <b-tag type="is-aquamarine">
                  {{ $gettext(filterTagLabelLeft(field)) }}
                </b-tag>
                <b-tag type="is-basalt">
                  {{ filterTagLabelRight(field, value) }}
                </b-tag>
              </b-taglist>
            </div>
          </div>
        </b-field>
      </div>

      <!-- RESEARCH ACTIVITY | metadata box -->
      <div>
        <div class="print-metadata-box">
          <div class="print-metadata-columns">
            <div class="print-metadata-label"><translate>tag.static.printedPageOfPagesLabel</translate></div>
            <div class="print-metadata-value"><translate :translate-params="{page, totalTablePages}">tag.static.printedPageOfPagesValue</translate></div>
          </div>
          <div class="print-metadata-columns">
            <div class="print-metadata-label"><translate>tag.static.resultCount</translate></div>
            <div class="print-metadata-value">{{total[resourceType]}}</div>
          </div>
          <div class="print-metadata-columns">
            <div class="print-metadata-label"><translate>tag.static.entriesPerPage</translate></div>
            <div class="print-metadata-value">{{config[resourceType].perPage}}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="fob-hide-in-print"
      style="display: flex; margin-bottom: 15px; align-items: center;"
    >
      <!-- RESEARCH ACTIVITIY | Per page -->
      <div style="display:flex; align-items: center;">
        <b-icon
          class="has-text-aquamarine"
          style="margin-right: 10px;"
          pack="fa"
          icon="list-ul"
        ></b-icon>
        <b-select
          v-model="config[resourceType].perPage"
          @input="onPerPageChange"
          style="margin-right: 0px;"
        >
          <option value="5">5 <translate>list.header.perPage</translate></option>
          <option value="10">10 <translate>list.header.perPage</translate></option>
          <option value="15">15 <translate>list.header.perPage</translate></option>
          <option value="20">20 <translate>list.header.perPage</translate></option>
          <option value="100">100 <translate>list.header.perPage</translate></option>
        </b-select>
      </div>
      <!-- RESEARCH ACTIVITIY | Sorting -->
      <fob-public-list-sort
        :key="resourceType"
        :resourceType="resourceType"
        :sortOrder="config[resourceType].sortOrder"
        :sortField="config[resourceType].sortField"
        :sortFields="config[resourceType].sortFields"
        @update:sortOrderPublicView="onUpdateSortOrder"
        @update:sortFieldPublicView="onUpdateSortField"
      ></fob-public-list-sort>
    </div>
    <div
      class="fob-hide-in-print"
      style="display: flex; margin-bottom: 15px; align-items: center;"
    >
      <!-- RESEARCH ACTIVITIY | Filters -->
      <fob-public-list-filter :key="resourceType" :resourceType="resourceType"></fob-public-list-filter>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import PublicListSort from '@/components/public/PublicListSort'
import PublicListFilter from '@/components/public/PublicListFilter'
import PublicViewHelper from '@/components/mixins/PublicViewHelper'

export default {
  name: 'fob-public-list-options',
  props: ['resourceType'],
  mixins: [PublicViewHelper],
  computed: {
    ...mapGetters({
      config: 'publicView/getConfig',
      total: 'publicView/getTotal',
      filter: 'publicView/getFilter'
    }),
    activeFilter () {
      return this.filter[this.activeResourceType].filter
    },
    page () {
      return this.config[this.activeResourceType].page
    },
    totalTablePages () {
      return Math.ceil(this.total[this.activeResourceType] / this.config[this.activeResourceType].perPage)
    }
  },
  methods: {
    onPerPageChange (perPage) {
      this.$store.dispatch('publicView/changePerPage', {
        resourceType: this.activeResourceType,
        perPage
      }).then(() => {
        this.loadAsyncData()
      })
    },
    filterTagLabelLeft (filterField) {
      return this.filter[this.activeResourceType].filters.find(filter => {
        return filter.value === filterField
      }).label
    },
    filterTagLabelRight (filterField, filterValue) {
      let filterConfig = this.filter[this.activeResourceType].filters.find(filter => {
        return filter.value === filterField
      })
      if (filterConfig.type === 'select') {
        return this.$gettext(`Public.filter.${filterField}.${filterValue.toLowerCase()}`)
      } else {
        return filterValue
      }
    },
    onUpdateSortField (sortField) {
      this.$store.dispatch('publicView/setSortField', {
        resourceType: this.resourceType,
        sortField
      }).then(() => {
        this.loadAsyncData()
      })
    },
    onUpdateSortOrder (sortOrder) {
      this.$store.dispatch('publicView/setSortOrder', {
        resourceType: this.resourceType,
        sortOrder
      }).then(() => {
        this.loadAsyncData()
      })
    }
  },
  components: {
    'fob-public-list-sort': PublicListSort,
    'fob-public-list-filter': PublicListFilter
  }
}

</script>

<style lang="scss">

  .print-metadata-box {
    width: 275px;
    border: black solid 1px;
    border-radius: 2px;
    font-size: 10px !important;
    position: absolute;
    right: 0px;
    top: 0px;

    .print-metadata-columns {
      display: flex;
      justify-content: flex-end;
      margin-left: 5px;

      .print-metadata-label {
        flex: none;
        padding: 0px;
        width: 70%;
      }

      .print-metadata-value {
        display: block;
        flex-basis: 0;
        flex-shrink: 1;
        flex-grow: 1;
        padding: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/PublicListOptions.vue